import { commonApiV1 as commonApi } from '@deepup/apis';

type FetchFunction<T> = (args: { options?: commonApi.ListOptions }) => Promise<{
  items: T[];
  paginationInfo?: commonApi.PaginationInfo;
}>;

export const fetchAllPages = async <T>({
  fetchFunction,
  pageSize = 100,
}: {
  fetchFunction: FetchFunction<T>;
  pageSize?: number;
}) => {
  const allItems: T[] = [];

  const { paginationInfo, items } = await fetchFunction({
    options: {
      contextId: '',
      pageSize,
      page: BigInt(0),
      withPaginationInfo: true,
    },
  });

  if (items && items.length > 0) {
    allItems.push(...items);
  }

  const totalPages = paginationInfo?.totalPages ?? BigInt(0);

  for (let i = 1; i < totalPages; i++) {
    const { items } = await fetchFunction({
      options: {
        pageSize,
        page: BigInt(i),
        contextId: '',
        withPaginationInfo: true,
      },
    });

    if (items && items.length > 0) {
      allItems.push(...items);
    }
  }

  return { data: allItems };
};
